export const primaryAppBarColor = "#23395B";
export const primaryButtonColor = "#10AAFF";
export const primaryButtonHoverColor = "#007DC3";
